import React, { Component } from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import { deleteProjectsDirectory, getListProjectsDirectory } from '../app/store/actions/projectsDirectory';
import ModalComponent from '../components/modal';
import Table from '../components/table/table';
import ROUTES from '../data/routes';
import { history } from '../routers/AppRouter';

class ProjectsDirectoryPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: 20,
      page: 1,
      search: '',
      orderBy: 'DESC',
      field: 'createdAt',
      dataList: [],
      totalRecord: 0,
      showModal: false,
      showCancel: false,
      titleModal: '',
      titleModalBody: '',
      selectedLine: {},
    };

    this.tableHeader = [
      { key: 'id', value: I18n.t('id') },
      { key: 'opportunities', value: I18n.t('opportunities') },
      { key: 'efkCode', value: I18n.t('efkCode') },
      { key: 'projectName', value: I18n.t('projectName') },
      { key: 'director', value: I18n.t('director') },
      { key: 'segment', value: I18n.t('segment2') },
      { key: 'stage', value: I18n.t('stage') },
      { key: 'action', value: I18n.t('action') },
    ];
  }

  componentDidMount() {
    this.getListProjectsDirectory();
  }

  adjustData = async (count = 0, rows = []) => {
    const dataList = rows.map(element => ({
      key: element.id,
      id: element.id,
      opportunities: element.opportunities,
      efkCode: element.efkCode,
      projectName: element.projectName,
      director: element.director,
      segment: element.segment,
      stage: element.stage,
      action: (
        <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
          <div className="btn-group" role="group">
            <button
              id="btnGroupDrop1"
              type="button"
              className="btn btn-secondary dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {I18n.t('action')}
            </button>
            <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
              <button
                type="button"
                className="dropdown-item dropdown-table"
                onClick={() => {
                  history.push({
                    pathname: ROUTES.FORM,
                    screenComming: 'projectsDirectory',
                    selectedLine: element,
                  });
                }}
              >
                {I18n.t('edit')}
              </button>
              <button
                type="button"
                className="dropdown-item dropdown-table"
                onClick={() => {
                  this.setState({
                    selectedLine: { ...element },
                    showModal: true,
                    showCancel: true,
                    titleModal: I18n.t('delete'),
                    titleModalBody: I18n.t('canNotBeUndone'),
                  });
                }}
              >
                {I18n.t('delete')}
              </button>
            </div>
          </div>
        </div>
      ),
    }));

    this.setState({
      totalRecord: count,
      dataList,
    });
  }

  getListProjectsDirectory = async () => {
    const {
      search, page, limit, orderBy = '', field = '',
    } = this.state;
    const skip = (page - 1) * limit;

    try {
      const { count = 0, rows = [] } = await this.props.getListProjectsDirectory(
        limit, skip, search, orderBy, field,
      );

      await this.adjustData(count, rows);
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;
      if (error && error.message) {
        const messageError = (error.code && error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: messageError,
        });
      } else {
        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: I18n.t('erroFetch'),
        });
      }
    }
  }

  deleteProjectsDirectory = async () => {
    this.setState({ showModal: false });
    try {
      await this.props.deleteProjectsDirectory(this.state.selectedLine.id);
      await this.getListProjectsDirectory();
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;
      if (error && error.message) {
        const messageError = (error.code && error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: messageError,
        });
      } else {
        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: I18n.t('erroFetch'),
        });
      }
    }
  }

  sortTable = async (field, orderBy) => {
    await this.setState({ orderBy, field });
    await this.getListProjectsDirectory();
  }

  searchTable = async (search = '', page = 1) => {
    await this.setState({ search, page });
    await this.getListProjectsDirectory();
  }

  tableButtons = () => (
    <React.Fragment>
      <button
        onClick={() => history.push(ROUTES.UPLOAD_PROJECTS_DIRECTORY)}
        type="button"
        className="btn btn-secondary margin-left-10"
      >
        {I18n.t('import')}
      </button>
    </React.Fragment>
  )

  render() {
    const {
      limit, page, dataList, totalRecord, titleModal, titleModalBody, showModal, showCancel,
    } = this.state;

    return (
      <div className="main-div-tables">

        <ModalComponent
          title={titleModal}
          showCancel={showCancel}
          body={titleModalBody}
          visible={showModal}
          closeModal={() => this.setState({ showModal: false })}
          titleOkButtoon={I18n.t('ok')}
          size={{ width: '350px', height: '200px' }}
          showButtons
          confirmModal={() => ((showCancel)
            ? this.deleteProjectsDirectory()
            : this.setState({ showModal: false }))
          }
        />

        <Table
          title={I18n.t('projectsDirectory')}
          buttons={this.tableButtons()}
          header={this.tableHeader}
          lines={dataList}
          page={page}
          perPage={limit}
          count={totalRecord || 0}
          searchItems={this.searchTable}
          showItemsCount
          sortTable={this.sortTable}
        />

      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getListProjectsDirectory: (limit, skip, search, orderBy, field) => dispatch(
    getListProjectsDirectory(limit, skip, search, orderBy, field),
  ),
  deleteProjectsDirectory: projectsDirectoryId => dispatch(
    deleteProjectsDirectory(projectsDirectoryId),
  ),
});

const mapStateToProps = (/* state */) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ProjectsDirectoryPage);
